import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { ApplicationsStore } from 'pages/settings/pages/developer/pages/applications/store/applicationsStore'

export const ApplicationsViewContext = createContext<ApplicationsStore | null>(null)

export const useApplicationsViewContext = () => {
  const context = useContext(ApplicationsViewContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ApplicationsViewContext')

  return context
}

export const ApplicationsViewProvider = ({ children }: PropsWithChildren) => {
  const store = useMemo(() => new ApplicationsStore(), [])

  useEffect(() => {
    void store.init()
    return () => store.dispose()
  }, [store])

  return (
    <ApplicationsViewContext.Provider value={store}>{children}</ApplicationsViewContext.Provider>
  )
}
